<script>
  import {updateDetail, deleteDetail} from './stores/inventory.js'

  export let itemName
  export let detail
  export let column
  export let value
  export let editingRows
  let isSubmitting = false;

  $: editRow = $editingRows.find((d) => d.id === detail.id)

  const handleRowClick = (detalId) => {
    if (editRow) {
      return
    }

    editingRows.update(rows => {
      return [...rows, {id: detail.id} ]
    })
  }

  const handleCancel = () => {
    isSubmitting = false;
    editingRows.update(rows => {
      return rows.filter((d) => d.id !== detail.id)
    })
  }

  const handleSave = async () => {
    isSubmitting = true;
    const {id, ...params} = editRow
    // Normalize cost to two decimal places, like other money values.
    if (params.cost != null && params.cost !== '') {
      params.cost = Number(Number(params.cost).toFixed(2))
    }
    try {
      await updateDetail(id, params)
    } catch (e) {
    }
    handleCancel()
  }

  const handleDelete = async () => {
    if (confirm(`Are you sure you want to delete ${itemName}`)) {
      deleteDetail(detail.id)
    }
  }
</script>

<div style="display: flex; justify-content: space-around; min-width: 135px">
{#if editRow}
    <button class="btn btn-sm btn-primary" on:click={() => handleSave()} disabled={isSubmitting}>Save</button>
    <button class="btn btn-sm btn-danger" on:click={() => handleCancel()} disabled={isSubmitting}>Cancel</button>
{:else}
   
  <button class="btn btn-sm btn-outline-secondary" on:click={() => handleRowClick()}>Edit</button>
  <button class="btn btn-sm btn-outline-danger" on:click={() => handleDelete()}>Delete</button>
{/if}
</div>
